Ply.AllocationWizardStep = function(el, options) {
    this.dom = {
        el: el
    };
    this.options = options;

    this.render = this.render.bind(this);
};

Ply.AllocationWizardStep.prototype.render = function() {
};

Ply.AllocationWizardStep.prototype.disableButtons = function() {
    Ply.makeArray(this.dom.el.querySelectorAll("button")).forEach(function(el) {
        el.disabled = true;
    })
};

Ply.AllocationWizardStep.prototype.enableButtons = function() {
    Ply.makeArray(this.dom.el.querySelectorAll("button")).forEach(function(el) {
        el.disabled = false;
    })
};

Ply.AllocationWizardStep.prototype.buttonSubmittingText = function() {
    return "Submitting<span class='saving'><span>.</span><span>.</span><span>.</span></span>";
};
